import type { Cart } from "@packages/sdk";

import type { Payment } from "../types/payment.types";
import { getTrialType } from "./getTrialType";
import { getValueFromTrialType } from "./getValue/getValueFromTrialType";

type GetAmountsCartProps = {
  cart?: Cart;
};

export const getAmountsCart = ({
  cart,
}: GetAmountsCartProps): Payment["amounts"] => {
  const isTaxInclusive = cart?.is_tax_inclusive ?? false;
  const trialType = getTrialType({ cart });

  const afterTrial = cart && trialType ? (cart.total ?? 0) : null;
  const renewal = cart ? (cart.renewal_total ?? 0) : null;
  const today = getValueFromTrialType({
    trialType,
    values: {
      default: cart?.total ?? 0,
      free: 0,
      paid: cart?.intro_offer?.amount ?? 0,
    },
  });

  return {
    afterTrial,
    afterTrialPreTax: isTaxInclusive
      ? afterTrial
      : cart && trialType
        ? (cart.pretax_total ?? 0)
        : null,
    renewal,
    renewalPreTax: isTaxInclusive
      ? renewal
      : cart
        ? (cart.renewal_pretax_total ?? 0)
        : null,
    today: getValueFromTrialType({
      trialType,
      values: {
        default: cart?.total ?? 0,
        free: 0,
        paid: cart?.intro_offer?.amount ?? 0,
      },
    }),
    todayPreTax: isTaxInclusive
      ? today
      : getValueFromTrialType({
          trialType,
          values: {
            default: cart?.pretax_total ?? 0,
            free: 0,
            paid: cart?.intro_offer?.amount ?? 0,
          },
        }),
  };
};
